<template>
  <el-row class="container">
    <!--头部-->
    <el-col :span="24">
      <router-view name="top"></router-view>
    </el-col>
    <el-col :span="24" class="main">
      <!--左侧导航-->
      <router-view name="aside"></router-view>
      <!--右侧内容区-->
      <section class="content-container">
        <router-view name="activeTabs"></router-view>
        <div class="grid-content bg-purple-light">
          <transition name="fade" mode="out-in">
            <keep-alive :include="alivePageList">
              <router-view></router-view>
            </keep-alive>

          </transition>
        </div>
      </section>
    </el-col>
  </el-row>
</template>
<script>
  import { userInfoApi } from '@/services/user'
  export default {
    name: 'home',
    data() {
      return {
        loading: false,
        requestParams: {
          id: 1
        },
        userMenu: [],
        // 需要缓存的页面列表
        alivePageList: ['companyPageCustom']
      }
    },
    methods: {
      getUserMenu() {
        userInfoApi.getUserMenu({
          params: {
            system_no: 'ggzx',
            is_tab: 1
          }
        }).then(res => {
          // console.log(res, 'user menu')
          if (res.code === 0) {
            this.userMenu = res.data
            this.setUserMenu()
          }
        })
      },
      setUserMenu() {
        let roleInfo = {
          nav: {
            index: [
              {
                title: '系统首页',
                children: [{ title: '系统首页-1', route: '11' }, { title: '系统首页-2' }]
              },
              {
                title: '账户设置',
                children: [{ title: '账户设置-1' }, { title: '账户设置-2' }]
              },
              {
                title: '登录信息',
                children: [{ title: '登录信息-1' }, { title: '登录信息-2' }]
              }
            ]
          },
          topNav: [

          ]
        }
        let first = ''
        this.userMenu.map(item => {
          roleInfo.nav[item.menu_id] = item.children_list
          roleInfo.topNav.push(item)
        })
        first = roleInfo.topNav[0].menu_id
        this.$store.dispatch('addRole', roleInfo)
        window.localStorage.setItem('roleInfo', JSON.stringify(roleInfo))
        if (window.localStorage.getItem('sideNav') === 'undefined' || window.localStorage.getItem('sideNav') === null) {
          this.$store.dispatch('sideNav', roleInfo.nav[first])
          window.localStorage.setItem('sideNav', JSON.stringify(roleInfo.nav[first]))
        }
        // console.log(roleInfo, 'role info')
      }
    },
    created() {
      let query = this.$route.query

      if (query.short_token) {
        window.sessionStorage.setItem('short_token', query.short_token)
      }
      this.getUserMenu()
      // console.log(userlisttApi);
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/index.vue